<script>
   /**************************************************************/
   /* Svelte component for ScoresPlot settings                   */
   /**************************************************************/

   import { Container, CompSelector } from '../controls';

   export let params;
   export let pvoptions;
   export let model;
   export let res;

   let comp1 = 1;
   let comp2 = pvoptions && pvoptions.ncompSel > 1 ? 2 : 1;

   $: params = {
      'comp': [comp1, comp2],
   }
</script>

<Container label="">
<p class="title">Scores</p>
</Container>

{#if model && res && pvoptions}
<CompSelector bind:value={comp1} label='LV for x-axis' maxNComp={pvoptions.ncompSel} />
<CompSelector bind:value={comp2} label='LV for y-axis' maxNComp={pvoptions.ncompSel} />
{/if}

